import { render, staticRenderFns } from "./hair-form.vue?vue&type=template&id=d253ac1e&scoped=true&"
import script from "./hair-form.vue?vue&type=script&lang=js&"
export * from "./hair-form.vue?vue&type=script&lang=js&"
import style0 from "./hair-form.vue?vue&type=style&index=0&id=d253ac1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d253ac1e",
  null
  
)

export default component.exports